import baseEditForm from 'formiojs/components/_classes/component/Component.form';
import RadioEditData from 'formiojs/components/radio/editForm/Radio.edit.data';
import RadioEditDisplay from 'formiojs/components/radio/editForm/Radio.edit.display';
import RadioEditValidation from 'formiojs/components/radio/editForm/Radio.edit.validation';

export default (...extend) => baseEditForm(
  [
    {
      key: 'display',
      components: RadioEditDisplay,
    },
    {
      key: 'data',
      components: RadioEditData,
    },
    {
      key: 'validation',
      components: RadioEditValidation,
    },
    {
      key: 'addons',
      ignore: true,
    },
    {
      label: 'Custom',
      key: 'custom',
      components: [
        {
          weight: 3000,
          type: 'checkbox',
          label: 'Hide Custom Label',
          tooltip:
              'Hide the label (title, if no label) of this component. This allows you to show/hide the custom label when it is rendered.',
          key: 'hideCustomLabel',
          input: true,
        },
      ],
    },
    {
      label: 'Review',
      key: 'review',
      components: [
        {
          weight: 50,
          type: 'checkbox',
          label: 'Use Custom Label',
          tooltip:
              'Use custom label for this component on the review page.',
          key: 'useReviewLabel',
          input: true,
        },
        {
          weight: 100,
          type: 'textfield',
          label: 'Review Page Label',
          key: 'reviewLabel',
          input: true,
        },
      ],
    },
  ],
  ...extend,
);
